import React from "react";
import Buttonlist from "./Buttonlist";
import Videocontainer from "./Videocontainer";

const Maincontainer = () => {
  return (
    <div>
      <Buttonlist />
      <Videocontainer />
    </div>
  );
};

export default Maincontainer;
